import React from "react";
import { BaseProvider } from "baseui";
import { ThemeProvider } from "styled-components";
import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";
import { ThemeProvider as MaterialThemeProvider, THEME_ID } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import materialTheme from "../../../components/styling/material_theme";
import baseuiTheme from "../../styling/baseui_theme";
import deprecatedTheme from "../../styling/deprecated_theme";
import { LoginPage } from "../../login";
import { StyledCard } from "../../shared/login_and_sign_up/styled";
import ProgramSchoolLogoBlock from "../../shared/login_and_sign_up/program_school_logo_block";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SetNewPasswordContent from "./set_new_password_content";
import NewPasswordSetContent from "./new_password_set_content";
import PasswordExpiredContent from "./password_expired_content";
import { SnackbarProvider } from "../../components/base_ui/progress_and_validation/snackbar";
import { DURATION } from "baseui/snackbar";
import { useDocumentTitle } from "../../use_document_title";
import PasswordLinkResentContent from "./password_link_resent_content";

const engine = new Styletron();

export default function SetUserPassword({
  actionKey,
  linkExpired,
  baseUrl,
  schoolLogo,
  schoolName,
}: {
  actionKey: string;
  linkExpired: boolean;
  baseUrl: string;
  schoolLogo: string;
  schoolName: string;
}) {
  useDocumentTitle("Password Reset");

  return (
    <BrowserRouter basename={"/password_reset/new_password"}>
      <StyletronProvider value={engine}>
        <BaseProvider theme={baseuiTheme}>
          <ThemeProvider theme={{ ...deprecatedTheme, ...baseuiTheme }}>
            <MaterialThemeProvider theme={{ [THEME_ID]: materialTheme }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SnackbarProvider defaultDuration={DURATION.medium}>
                  <LoginPage>
                    <StyledCard>
                      <ProgramSchoolLogoBlock
                        programLogo={undefined}
                        programName={undefined}
                        schoolLogo={schoolLogo}
                        schoolName={schoolName}
                      />
                      <Routes>
                        <Route
                          path="/"
                          element={
                            !linkExpired ? (
                              <SetNewPasswordContent actionKey={actionKey} />
                            ) : (
                              <PasswordExpiredContent actionKey={actionKey} />
                            )
                          }
                        />
                        <Route
                          path="new_password_set"
                          element={<NewPasswordSetContent baseUrl={baseUrl} />}
                        />
                        <Route path="password_link_reset" element={<PasswordLinkResentContent />} />
                      </Routes>
                    </StyledCard>
                  </LoginPage>
                </SnackbarProvider>
              </LocalizationProvider>
            </MaterialThemeProvider>
          </ThemeProvider>
        </BaseProvider>
      </StyletronProvider>
    </BrowserRouter>
  );
}
